import { RootState } from "@/store/store";
import { commitmentsDetailsDrawerTargetIdSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerTargetIdSelector";
import { savingsPlansDataSelector } from "@/store/commitments/selectors/coverage-and-utilization/data/savingsPlansDataSelector";

export const selectedSavingsPlanProviderIdSelector = (state: RootState) => {
  const id = commitmentsDetailsDrawerTargetIdSelector(state);
  const savingsPlans = savingsPlansDataSelector(state);

  return savingsPlans?.find(
    (savingsPlan) => savingsPlan.provider_unique_id === id,
  )?.provider_unique_id;
};
